import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

const createBaseQuery = (baseUrl) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('Authorization', `JWT ${token}`);
      }
      return headers;
    },
  });

const baseQuery = createBaseQuery(
  `${process.env.REACT_APP_BACKEND_URL}health`,
);

const buildQueryWithFilters = (endpoint, filters) => {
  const params = new URLSearchParams(filters).toString();
  return `${endpoint}/?${params}`;
};

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: baseQuery,
  tagTypes: ['Prestations', 'Premiums'],
  endpoints: (builder) => ({
    getPrestations: builder.query({
      query: (filters) =>
        buildQueryWithFilters('getPrestations', filters),
      providesTags: [{ type: 'Prestations' }],
    }),
    listPrestations: builder.query({
      query: (filters) =>
        buildQueryWithFilters('prestations', filters),
      providesTags: [{ type: 'Prestations' }],
    }),
    getPremiums: builder.query({
      query: (filters) =>
        buildQueryWithFilters('getPremiums', filters),
      providesTags: [{ type: 'Premiums' }],
    }),
    getStats: builder.query({
      query: (filters) => buildQueryWithFilters('getStats', filters),
      providesTags: [{ type: 'Stats' }],
    }),
  }),
});

export const {
  useGetPrestationsQuery,
  useListPrestationsQuery,
  useGetPremiumsQuery,
  useGetStatsQuery,
} = dashboardApi;
